import GroupOutlineIcon from '@eduzz/houston-icons/GroupOutline';
import Topbar from '@eduzz/houston-ui/Layout/Topbar';
import Badge from '@material-ui/core/Badge';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import Popover from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Spin from 'components/Spin';
import Truncate from 'components/Truncate';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { listAffiliatesNotifications, moderateAffiliate } from 'store/Orbita/Affiliate/actions';

import type { DispatchProp } from 'react-redux';

const styles = withStyles((theme) => ({
  menu: {
    minWidth: 280,
  },
  chatList: {
    width: '100%',
  },
  affiliationItem: {
    color: '#333',
    fontSize: 14,
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&.--not-read': {
      opacity: 1,
    },
    '&:hover': {
      background: '#f9f9f9',
    },
  },
  affiliationActions: {
    marginLeft: 16,
  },
  thumbsUp: {
    color: '#009358',
  },
  thumbsDown: {
    color: '#333',
  },
  affiliationContent: {
    color: '#333',
  },
  affiliationTitle: {
    fontWeight: 500,
    display: 'block',
    marginBottom: 4,
  },
  affiliationText: {
    color: '#999',
    marginBottom: 4,
    display: 'block',
  },
  affiliationDate: {
    fontSize: 12,
    color: '#999',
  },
  viewMore: {
    textAlign: 'center',
    color: '#333',
    display: 'block',
    width: '100%',
    padding: 8,
    fontSize: 13,
    fontWeight: 500,
  },
  loading: {
    minWidth: 280,
    textAlign: 'center',
    padding: '12px 0',
  },
  notFound: {
    width: '100%',
    textAlign: 'center',
    fontSize: 14,
    color: '#333',
    padding: theme.spacing(1),
  },
  badge: {
    top: 5,
    rigth: -4,
  },
  iconButton: {
    color: '#fff',
  },
}));

interface IProps extends DispatchProp<any> {
  classes: any;
  notifications: any;
}

interface IStates {
  anchorEl: any;
  loading: boolean;
}

class AffiliationsNotification extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      anchorEl: null,
      loading: false,
    };
  }

  moderateAffiliate = (affiliateId: any, status: any) => {
    (async () => {
      try {
        this.setState({ loading: true });
        await this.props.dispatch(moderateAffiliate(affiliateId, status));
        await this.updateListAffiliations({ page: 1, per_page: 4 });
        this.setState({ loading: false });
      } catch (error) {
        toast.error('Erro ao alterar status dos afiliado');
        this.setState({ loading: false });
      }
    })();
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleClick = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  updateListAffiliations = async (pagination?: any) => {
    await this.props.dispatch(listAffiliatesNotifications(pagination, 'pending', 'desc'));
  };

  componentDidMount() {
    this.updateListAffiliations({ page: 1, per_page: 4 });

    let updateInSeconds = 1800000;
    setInterval(() => {
      this.updateListAffiliations({ page: 1, per_page: 4 });
    }, updateInSeconds * 1000);
  }

  render() {
    const { classes, notifications } = this.props;
    const { anchorEl, loading } = this.state;

    return (
      <>
        <Tooltip title='Solicitações de afiliação' placement='bottom'>
          <span>
            <Topbar.Action
              id='topbar-action-affiliates-requests'
              aria-label='mostrar solicitações'
              onClick={this.handleClick}
              icon={
                notifications?.isFetching ? (
                  <CircularProgress size={24} />
                ) : (
                  <Badge classes={{ badge: classes.badge }} color='error' badgeContent={notifications?.pagination?.pendent_count ?? 0}>
                    <GroupOutlineIcon color='currentColor' size={24} />
                  </Badge>
                )
              }
            />
          </span>
        </Tooltip>

        <Popover
          id='simple-menu'
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          classes={{ paper: classes.menu }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <div className={classes.chatList}>
            <Typography align='center' variant='subtitle1'>
              Solicitações de afiliação
            </Typography>
            <Divider />
            {((notifications && notifications.isFetching) || loading) && (
              <div className={classes.loading}>
                <Spin />
              </div>
            )}

            {!loading &&
              !notifications?.isFetching &&
              notifications?.data?.map((affiliation: any, index: any) => {
                return (
                  <div className={`${classes.affiliationItem}`} key={'notifications-' + index}>
                    <Link to={'/producer/myaffiliates'} onClick={this.handleClose}>
                      <div className={classes.affiliationContent}>
                        <div className={classes.affiliationTitle}>
                          <Truncate count={25} final='...'>
                            {affiliation.affiliate_name}
                          </Truncate>
                        </div>
                        <div className={classes.affiliationText}>
                          <Truncate count={25} final='...'>
                            {affiliation.product_title}
                          </Truncate>
                        </div>
                        <div className={classes.affiliationDate}>{affiliation.request_date && moment(affiliation.request_date).fromNow()}</div>
                      </div>
                    </Link>

                    <div className={classes.affiliationActions}>
                      <Tooltip title='Aprovar' placement='top'>
                        <Icon
                          style={{ fontSize: '1rem', marginRight: '8px', cursor: 'pointer' }}
                          className={classes.thumbsUp}
                          color='primary'
                          onClick={() => this.moderateAffiliate(affiliation.id, 'A')}
                        >
                          thumb_up
                        </Icon>
                      </Tooltip>
                      <Tooltip title='Reprovar' placement='top'>
                        <Icon
                          style={{ fontSize: '1rem', cursor: 'pointer' }}
                          className={classes.thumbsDown}
                          onClick={() => this.moderateAffiliate(affiliation.id, 'R')}
                        >
                          thumb_down
                        </Icon>
                      </Tooltip>
                    </div>
                  </div>
                );
              })}

            {!loading && !notifications?.isFetching && !notifications?.data?.length && (
              <div className={classes.notFound}>
                <Typography align='center' variant='body1'>
                  Nenhuma solicitação de afiliação
                </Typography>
              </div>
            )}
          </div>

          <div className='m4'></div>
          <Divider />
          <div className='m4'></div>

          <Link to={'/producer/myaffiliates'} onClick={this.handleClose}>
            <span className={classes.viewMore}>VER TODOS</span>
          </Link>
        </Popover>
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    notifications: state.orbita.Affiliate.notifications,
  };
}

export default connect(mapStateToProps)(styles(AffiliationsNotification));
